import React from "react";
import PropTypes from "prop-types";
import { FiInbox } from "react-icons/fi";

// Shown in place of a list or section that has nothing to display
function EmptyState({ icon: Icon = FiInbox, title, description, className = "" }) {
  return (
    <div
      className={`flex w-full flex-col items-center justify-center gap-3 px-4 py-10 text-center ${className}`}
    >
      <div className="flex h-20 w-20 items-center justify-center rounded-full bg-primary/10 text-primary">
        <Icon size={40} />
      </div>
      <span className="text-[20px] font-semibold text-primary lg:text-[24px]">
        {title}
      </span>
      {description && (
        <span className="max-w-md text-[14px] text-secondary lg:text-[16px]">
          {description}
        </span>
      )}
    </div>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  className: PropTypes.string,
};

export default EmptyState;
